<template>
  <div class="banner-container">
    <div class="banner-content">
      <div class="card" @click="goToPublication(mainPublication.id)">
        <div class="image-wrapper">
          <b-skeleton-img v-if="imageLoading || !mainPublication.image" class="skeleton-layer" no-aspect
            height="400px"></b-skeleton-img>

          <img v-show="!imageLoading && mainPublication.image" class="image-content" :src="mainPublication.image"
            @error="handleImageError">
        </div>
        <div class="card-body">
          <div class="card-title">
            {{ mainPublication.title }}
          </div>
          <div class="card-subtitle">
            {{ mainPublication.resume }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fallbackImage from '@/assets/images/error-banner.svg';
import RoutesPaths from '../../../router/router-structure/routes-paths';

export default {
  props: {
    imageLoading: {
      type: Boolean,
      default: false
    },
    mainPublication: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        title: '',
        resume: '',
        image: null
      })
    },
  },
  data() {
    return {
      fallbackImage: fallbackImage
    }
  },
  computed: {
    displayImage() {
      return this.mainPublication.image || null;
    }
  },
  methods: {
    handleImageError(event) {
      event.target.src = fallbackImage;
    },
    goToPublication(id) {
      this.$router.push({
        path: RoutesPaths.connection.preview(id)
      });
    },
  },
}
</script>

<style scoped>
.banner-container {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
  padding: 1rem 0;
}

.banner-content {
  width: 100%;
  padding-bottom: 20px;
}

/* Crucial para não piscar: o wrapper deve ter a altura fixa da imagem */
.image-wrapper {
  position: relative;
  min-height: 400px;
  background: #f8f9fa;
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  align-content: center;
}

.skeleton-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.image-content {
  width: 100%;
  max-height: 400px;
  /* Force a altura para bater com o skeleton */
  object-fit: cover;
  display: block;
  /* Transição suave impede o efeito de "flash" */
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card {
  border-radius: 16px;
  background: #FFF;
  border: none;
  cursor: pointer;
}

.card-body {
  padding: 16px;
}

.card-title {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 28px;
}

.card-subtitle {
  color: #343A40;
  font-family: "Trebuchet MS";
  font-size: 16px;
  font-style: normal;
}
</style>